module.exports = __webpack_public_path__ + "static/media/hs_15.5ca78a6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/heads/JPEG/hs_15.jpg
// module id = 5946
// module chunks = 0